import { Button } from '../../primitives';
import { styled } from '../../theme';

export const MoreButton = styled(Button).attrs((props) => ({
	variant: 'transparent',
	...props,
}))`
	width: 100%;
`;
